export default theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    '& .imports__toolbar__export-btn': {
      margin: '8px 0px'
    }
  },
  listContainer: {
    width: '100%',
    height: '100%',
    padding: '16px',
    paddingTop: '0px'
  },
  list: {
    flex: 1,
    height: 'auto',
    '& .ag-header-viewport .ag-header-cell': {
      '&::after': {
        border: 'none !important'
      }
    }
  }
});